export * from './mobile-browser-detection.component';
